// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-HR-PersonTargets-Manage-ManagePeriod-style__bold--v8T3C{font-weight:bold}.src-HR-PersonTargets-Manage-ManagePeriod-style__hr--VlpxB{opacity:.5}.src-HR-PersonTargets-Manage-ManagePeriod-style__manageCategory--bKLM1{margin-top:1em;margin-bottom:2em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bold": "src-HR-PersonTargets-Manage-ManagePeriod-style__bold--v8T3C",
	"hr": "src-HR-PersonTargets-Manage-ManagePeriod-style__hr--VlpxB",
	"manageCategory": "src-HR-PersonTargets-Manage-ManagePeriod-style__manageCategory--bKLM1"
};
export default ___CSS_LOADER_EXPORT___;
